import { Box, Grid } from "@mui/material";
import { SubmitHandler, useForm } from "react-hook-form";
import Input from "../../../components/input/Input-v2";
import { LoadingButton } from "../../../components/button/Button";
import { useEffect } from "react";
import {
  useAddSubDealer,
  useGetSubDealer,
  useUpdateSubDealer,
} from "../api/supplier/resolver";

interface Form {
  idSubDealer?: string;
}

export interface Form_Create_Dealer {
  sub_dealer_name: string;
  sub_dealer_phone_number: string;
  sub_dealer_address: string;
}

export interface Form_Update_Dealer extends Form_Create_Dealer {
  sub_dealer_id: string;
}

export default function Form({ idSubDealer }: Form) {
  const { mutate: mutateAddSubDealer, isLoading: loadingAddSubDealer } =
    useAddSubDealer();
  const { mutate: mutateUpdateSubDealer, isLoading: loadingUpdateSubDealer } =
    useUpdateSubDealer();
  const { data: dataRawSubDealer, isLoading: loadingFetchSupplier } =
    useGetSubDealer({ sub_dealer_id: idSubDealer });
  const dataSubDealer = dataRawSubDealer?.data?.data;
  const isAddFlow = idSubDealer === undefined;
  const isLoading = loadingAddSubDealer || loadingUpdateSubDealer;
  const { control, handleSubmit, setValue } = useForm<Form_Create_Dealer>({
    defaultValues: {
      sub_dealer_address: "",
      sub_dealer_name: "",
      sub_dealer_phone_number: "",
    },
  });

  useEffect(() => {
    if (dataSubDealer) {
      setValue("sub_dealer_address", dataSubDealer.sub_dealer_address);
      setValue("sub_dealer_name", dataSubDealer.sub_dealer_name);
      setValue(
        "sub_dealer_phone_number",
        dataSubDealer.sub_dealer_phone_number
      );
    }
  }, [dataSubDealer]);

  const handleFormSubmit: SubmitHandler<Form_Create_Dealer> = (data) => {
    if (isAddFlow) {
      mutateAddSubDealer({ ...data });
    } else {
      const body: Form_Update_Dealer = {
        sub_dealer_id: idSubDealer,
        ...data,
      };
      mutateUpdateSubDealer({ ...body });
    }
  };

  return (
    <Box>
      <form onSubmit={handleSubmit(handleFormSubmit)}>
        <Grid container spacing={2}>
          <Grid item xs={12} md={6}>
            <Input.Controller
              control={control}
              name="sub_dealer_name"
              rules={{ required: "Kolom ini tidak boleh kosong" }}
              render={(field, fieldState) => (
                <Input.Text
                  label="Nama sub dealer"
                  isFetching={loadingFetchSupplier}
                  value={field.value}
                  onChange={(e) => field.onChange(e)}
                  error={fieldState.error?.message}
                />
              )}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <Input.Controller
              control={control}
              name="sub_dealer_phone_number"
              rules={{ required: "Kolom ini tidak boleh kosong" }}
              render={(field, fieldState) => (
                <Input.Text
                  label="Telp sub dealer"
                  isFetching={loadingFetchSupplier}
                  value={field.value}
                  onChange={(e) => field.onChange(e)}
                  error={fieldState.error?.message}
                />
              )}
            />
          </Grid>
          <Grid item xs={12}>
            <Input.Controller
              control={control}
              name="sub_dealer_address"
              rules={{ required: "Kolom ini tidak boleh kosong" }}
              render={(field, fieldState) => (
                <Input.TextArea
                  row={10}
                  label="Alamat sub dealer"
                  isFetching={loadingFetchSupplier}
                  value={field.value}
                  onChange={(e) => field.onChange(e)}
                  error={fieldState.error?.message}
                />
              )}
            />
          </Grid>
          <Grid
            item
            xs={12}
            display={"flex"}
            justifyContent={"flex-end"}
            gap={2}
          >
            {!isAddFlow && <LoadingButton color="error" text="Hapus" />}
            <LoadingButton
              type="submit"
              isLoading={isLoading}
              text={isAddFlow ? "Tambah" : "Update"}
            />
          </Grid>
        </Grid>
      </form>
    </Box>
  );
}
